import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "./elements";

export const BettoFieldRoot = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	width: 100%;
	min-width: 0;
`;

export const BettoFieldLabel = styled.label`
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 500;
	line-height: 1.2;
`;

export const BettoFieldControl = styled.div`
	width: 100%;
	min-width: 0;
`;
